//CAREFUL!!!: They must be the same as on the DB
export const modulePermissions = {
    basic: "B",
    calculation: "C",
    sbv: "S",
    mobile: "M"
};
//CAREFUL!! They must be the same as in thx backend
export const sbvPermissions = {
    sbv: "S",
    sbvPreis: "SP",
    sbvModified: "SM"
};
//CAREFUL!! They must be the same as in the backend
export const systemFoundTypes = {
    ADVERTISEMENT_GOOGLE_SEARCH: 1,
    ADVERTISEMENT_POST: 2,
    ADVERTISEMENT_RECOMMENDATION: 3,
    ADVERTISEMENT_WEB: 4,
    ADVERTISEMENT_MAGAZINE: 5,
    ADVERTISEMENT_OTHERS: 6,
    ADVERTISEMENT_GAS_STATION: 7,
    ADVERTISEMENT_RADIO: 8
};
//CAREFUL!! They must be the same as in the backend
export const systemWorkTypes = {
    WORK_TYPE_PAINTER: 1,
    WORK_TYPE_PLASTERER: 2,
    WORK_TYPE_CONSTRUCTION: 3,
    WORK_TYPE_WOOD_CONSTRUCTION: 4,
    WORK_TYPE_TILER: 5,
    WORK_TYPE_SANITARY: 6,
    WORK_TYPE_NURSERY: 7,
    WORK_TYPE_JANITOR: 8,
    WORK_TYPE_STOVE_BUILDER: 9,
    WORK_TYPE_AGRICULTURE: 10,
    WORK_TYPE_OTHER: 11
};
